<template>
    <div class="container container-main-noticies">
        <div class="row row__tertiary-block" v-if="fixed || fixed_images">
            <div class="col-12 col-md-3 col-lg-3" v-for="index in [0,1,2]" :key="index">
                <template v-if="typeof fixed_images[index] !== 'undefined'">
                    <SuperLink class="main-noticies__bottom" :href="fixed_images[index].link" target="_self">
                        <div class="noticies-item--image">
                            <img v-if="fixed_images[index].image" :src="utils.image(fixed_images[index].image, 255, 165)" alt="">
                            <img v-else-if="fixed_images[index].link.image" :src="utils.image(fixed_images[index].link.image, 255, 165)" alt="">
                            <img v-else src="@/assets/images/search-placeholder.jpg" alt="">
                        </div>
                        <p class="noticies__label">
                            <strong v-if="fixed_images[index].hat">{{fixed_images[index].hat}}</strong>
                            <strong v-else-if="fixed_images[index] && fixed_images[index].link && fixed_images[index].link.editorial">
                                {{fixed_images[index].link.editorial.title}}
                            </strong>
                        </p>
                        <p class="noticies__title noticies__title--blue"><strong>{{fixed_images[index].title}}</strong></p>
                    </SuperLink>
                </template>
                <template v-if="typeof fixed[index] !== 'undefined'">
                    <SuperLink class="main-noticies__bottom --no-image" :href="fixed[index].link" target="_self">
                        <p class="noticies__label">
                            <strong v-if="fixed[index].hat">{{fixed[index].hat}}</strong>
                            <strong v-else-if="fixed[index] && fixed[index].link && fixed[index].link.editorial">
                                {{fixed[index].link.editorial.title}}
                            </strong>
                        </p>
                        <p class="noticies__title noticies__title--blue"><strong>{{fixed[index].title}}</strong></p>
                    </SuperLink>
                </template>
            </div>
            
            <div class="col-12 col-md-3 col-lg-3">
                <a v-if="cover && cover.gazeta"
                    class="main-noticies__capa" 
                    href="https://d.gazetadealagoas.com.br/" 
                    target="_blank" >
                    <img :src="utils.image(cover.gazeta.file, 379, 695)" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/utils'
import SuperLink from '@/components/SuperLink'

export default {
    name: 'Fixed',
    props: {
        'fixed':Array, 
        'fixed_images': Array, 
        'cover': Object
    },
    components:{SuperLink},
    data() {
        return {
            utils:utils
        }
    }
}
</script>